"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const __1 = require("..");
const Overlay_1 = require("../Overlay");
const Modal = ({ children, isOpen, onDismiss, size = "md" }) => {
    const clickingContent = react_1.default.useRef(false);
    const dismissable = !!onDismiss;
    const transform = isOpen
        ? ["translateY(0px)", "unset", null]
        : ["translateY(100%)", "unset", null];
    const { modalSize, modalPush } = react_1.default.useMemo(() => {
        // default modalDimensions are "md" size
        const modalDimensions = {
            modalSize: [4, 6, 8],
            modalPush: [0, 1, 2]
        };
        switch (size) {
            case "xs":
                modalDimensions.modalSize = [4, 4, 4];
                modalDimensions.modalPush = [0, 2, 4];
                break;
            case "sm":
                modalDimensions.modalSize = [4, 4, 6];
                modalDimensions.modalPush = [0, 2, 3];
                break;
            case "lg":
                modalDimensions.modalSize = [4, 8, 10];
                modalDimensions.modalPush = [0, 0, 1];
                break;
        }
        return modalDimensions;
    }, [size]);
    const handleClickOutside = react_1.default.useCallback(() => {
        if (!clickingContent.current) {
            if (onDismiss) {
                onDismiss();
            }
        }
        clickingContent.current = false;
    }, [onDismiss]);
    return (react_1.default.createElement(Overlay_1.Overlay, { visible: isOpen, onDismiss: onDismiss, sx: {
            alignItems: "center",
            cursor: dismissable ? "pointer" : "default",
            display: "flex"
        } },
        react_1.default.createElement(foundations_1.Grid, { initial: true, onClick: handleClickOutside },
            react_1.default.createElement(foundations_1.GridColumn, { size: modalSize, fillGap: true, sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: ["flex-end", "center", null],
                    minHeight: ["100dvh", "100vh"],
                    transition: "easeOutMedium",
                    transform: transform
                }, push: modalPush },
                react_1.default.createElement(foundations_1.Box, { onClick: () => {
                        clickingContent.current = true;
                    }, sx: {
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "background01",
                        cursor: "initial",
                        flexGrow: 0,
                        maxHeight: (theme) => `calc(100vh - ${theme.sizes[28]}px)`,
                        overflow: "auto",
                        borderRadius: [null, "medium"]
                    } },
                    dismissable && (react_1.default.createElement(foundations_1.Box, { sx: {
                            alignSelf: "flex-end",
                            paddingInlineEnd: 4,
                            paddingTop: 4
                        } },
                        react_1.default.createElement(__1.IconButton, { icon: "x", size: "base", variant: "transparent", onClick: () => {
                                clickingContent.current = true;
                                onDismiss();
                            }, "aria-label": "Close modal" }))),
                    children),
                dismissable && (react_1.default.createElement(foundations_1.Box, { sx: {
                        display: ["none", "block", null],
                        flex: 1,
                        maxHeight: 20,
                        minHeight: 8
                    } }))))));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map